// -------------------------------------
// Update Global Currency
// -------------------------------------
if (window.boostSDAppConfig && window.Shopify.locale == 'fr') {
    window.boostSDAppConfig.shop.money_format = '{{ amount_with_comma_separator }} $';
}

// -------------------------------------
// Product Card Addons
// -------------------------------------
const customProductCards = {
    updateProductItem: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Modify Product Item customHTML',
            enabled: true,
            apply: () => ({
                beforeInit(element) {},
                afterInit(element) {},
                render(elementModel, currentRenderElement) {
                    return currentRenderElement;
                },
                beforeRender(element) {},
                afterRender(element) {
                    const productData = element.getParams().props.product;

                    const productItems = document.querySelectorAll('[data-product-id="'+ productData.id +'"]');

                    productItems.forEach((productItem) => {
                        const productImageWrapper = productItem.querySelector('.boost-sd__product-image-wrapper');
                        const productInfo = productItem.querySelector('.boost-sd__product-info');
                        const productImage = productItem.querySelector('.boost-sd__product-item-grid-view-layout-image');
                        const productPrice = productItem.querySelector('.boost-sd__product-price-content');
                        const productImageLink = productItem.querySelector('.boost-sd__product-link');

                        const promoBadge = productImage.querySelector('.promo-options-badge');
                        if (!promoBadge) {
                            const promoBadgeHTML = getPromoBadge(productData);
                            if (promoBadgeHTML) productInfo.appendChild(promoBadgeHTML);
                        }

                        productImageLink.setAttribute('tabindex', '-1');

                        let productTitleOverride = getProductTitleOverride(productData);

                        if (productTitleOverride) {
                            const productTitle = productItem.querySelector('.boost-sd__product-title');
                            productTitle.textContent = productTitleOverride;
                        }

                        const colorSwatch = getColorSwatch(productData);

                        if (colorSwatch) {
                            let colorSwatch = getColorSwatch(productData);
                            const colorTitle = productItem.querySelector('.boost-sd__product-title');

                            // In French, capitalize only the first word
                            if (window.Shopify.locale == 'fr') {
                                colorSwatch['name'] = capitalizeFirstWord(colorSwatch.name.toLowerCase());
                            }

                            const div = document.createElement('div');
                            div.className = 'custom_swatch row';
                            div.innerHTML = `
                            <div>
                             <span>${colorSwatch.name} </span>
                            </div>`;

                            colorTitle.appendChild(div);
                        }


                        getProductFeaturesList(productData);
                    });
                }
            }),
        });
    }
};

// -------------------------------------
// Helper Functions
// -------------------------------------
function getPromoBadge(productData) {
    // Look for promo_message in metafields array
    let product_label;
    let csa_label;

    productData.metafields.forEach((metafield) => {
        if (window.Shopify.locale == 'fr') {
            if (metafield.key == 'product_tag_french') {
                product_label = metafield.value;
            }
        } else {
            if (metafield.key == 'product_tag') {
                product_label = metafield.value;
            }
        }
    });

    productData.metafields.forEach((metafield) => {
        if (metafield.key == 'csa_check') {
            csa_label = metafield.value;
        }
    });

    const promoBadgeEL = document.createElement('div');
    promoBadgeEL.classList.add('card__tags-wrapper');

    if (product_label) {
        promoBadgeEL.innerHTML += `<div class="card__tag">${product_label}</div>`;
    }

    if (csa_label == 'true') {
        promoBadgeEL.innerHTML += '<div class="card__tag">CSA</div>';
    }

    return promoBadgeEL;

}

function getColorSwatch(productData) {
    let swatchReference;
    let swatchObject;

    productData.metafields.forEach((metafield) => {
        if (metafield.key == 'color_swatch') {
            swatchReference = JSON.parse(metafield.value);
            return;
        }
    });

    if (!swatchReference) return false;


    // Get Color Swatch from Global variable based on ID
    window.iamotaColorSwatches.forEach((metaObjectColorSwatch) => {
        if (metaObjectColorSwatch.id == swatchReference[0].data.id) {
            swatchObject = metaObjectColorSwatch;
            return;
        }
    });

    return swatchObject;
}

function getProductTitleOverride(productData) {
    // Look for promo_message in metafields array
    let product_title = false;

    productData.metafields.every((metafield) => {
        if (window.Shopify.locale == 'fr') {
            if (metafield.namespace == 'iamota' && metafield.key == 'product_title_override_french') {
                product_title = metafield.value;
                return false;
            }
        } else {
            if (metafield.namespace == 'iamota' && metafield.key == 'product_title_override') {
                product_title = metafield.value;
                return false;
            }
        }
        return true;
    });

    return product_title;
}

function getProductFeaturesList(productData) {
    let product_features_list = false;
    console.log(productData.metafields);

    productData.metafields.every((metafield) => {
        if (metafield.namespace == 'custom' && metafield.key == 'product_features') {
            product_features_list = metafield.value;
            console.log(product_features_list);
            return false;
        }
        return true;
    });

    return product_features_list;
}

function capitalizeFirstWord(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// -------------------------------------
// Collection Grid Addons
// -------------------------------------
const customCollectionGrid = {
    updateProductList: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductList', {
            name: 'Modify List customHTML',
            enabled: true,
            apply: () => ({
                beforeInit(element) {
                },
                afterInit(element) { },
                render(elementModel, currentRenderElement) {
                    return currentRenderElement;
                },
                beforeRender(element) {
                    const renderedPromoCards = document.querySelectorAll('.boost-sd__product-item--promo-card');
                    renderedPromoCards.forEach((promoCard) => promoCard.remove());
                },
                afterRender(element) {
                    const renderedPromoCards = document.querySelectorAll('.boost-sd__product-item--promo-card');

                    if (renderedPromoCards.length > 0) return false;

                    const productItems = document.querySelectorAll('.boost-sd__product-item');
                    const promoCardsData = window.iamotaCollectionPromoCards;
                    const promoCardsEl = [];
                    const mobile = 600;

                    if (!promoCardsData) return false;

                    promoCardsData.forEach((promoCard) => {
                        const promoCardContainer = document.createElement('div');
                        promoCardContainer.classList.add('boost-sd__product-item', 'boost-sd__product-item--promo-card');

                        // Create Promo Cards from the array.
                        promoCardContainer.innerHTML = `
                        <a class="boost-sd__promo-card" href="${promoCard.cta_link}" target="_blank">
                            <div class="boost-sd__promo-card-media">
                                <img class="boost-sd__promo-card-image" src="${promoCard.image}" alt="${promoCard.title}" />
                            </div>

                            <div class="boost-sd__promo-card-content">
                                <div class="boost-sd__promo-card-title h4">${promoCard.title}</div>

                                <div class="boost-sd__promo-card-description">${promoCard.body}</div>

                                <div class="boost-sd__promo-card-button button button--secondary">
                                    ${promoCard.cta_label} <svg class="icon icon__arrow--cta-short button__icon" aria-hidden="true" focusable="false">
                                        <use xlink:href="#icon-arrow--cta-short"></use>
                                    </svg>
                                </div>
                            </div>
                        </a>
                    `;

                        promoCardsEl.push(promoCardContainer);
                    });

                    // Insert promo card when there are more than 5 products on the collection page
                    if (productItems.length > 5 && promoCardsEl.length > 0) {
                        // Insert Promo Card After 5th item
                        productItems[4].after(promoCardsEl[0]);
                    }


                    if (productItems.length > 5 && promoCardsEl.length > 0 && window.innerWidth <= mobile) {
                        // Insert Promo Card After 4th item
                        productItems[3].after(promoCardsEl[0]);
                    }

                }
            }),
        });
    }
};


// -------------------------------------
// Initialize Boost Custom Updates
// -------------------------------------
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customProductCards.updateProductItem,
    customCollectionGrid.updateProductList
]);
